import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";

import './i18n';
import GreenSpinner from "./components/loaders/GreenSpinner";

const SuspenseLoading = () => 
	<div 
		className="flex items-center justify-center"
		style={{
			height: "100vh",
			width: "100vw"
		}}
	>
		<GreenSpinner width={30} height={30}/>
	</div>


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Suspense fallback={<SuspenseLoading />}>
    	<BrowserRouter>
      		<Provider store={store}>
				<App />
			</Provider>
    	</BrowserRouter>
	</Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
